import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { TAX_ID_MAPPING, TaxID, TaxIDType } from '@journeyapps-platform/types-charging-station';
import { Input, InputWrapperWidget } from '../../../../../widgets/inputs';
import { SelectWidget } from '../../../../../widgets/select/SelectWidget';

export interface TaxIDWidgetProps {
  initial_tax: TaxID | null;
  onChange: (id: TaxID | null) => any;
  country_code?: string;
  className?: any;
}

export const TaxIDWidget: React.FC<TaxIDWidgetProps> = (props) => {
  const [type, setType] = useState<TaxIDType | null>(props.initial_tax?.type || TaxIDType.US_EIN);
  const [code, setCode] = useState<string | null>(props.initial_tax?.tax_id || null);

  useEffect(() => {
    if (props.initial_tax) {
      setType(props.initial_tax.type);
      setCode(props.initial_tax.tax_id);
    } else if (props.country_code) {
      let types = TAX_ID_MAPPING.filter((c) => c.country === props.country_code);
      if (types.length === 1) {
        setType(types[0].external_type);
      } else {
        setType(null);
      }
    }
  }, [props.country_code, props.initial_tax]);

  useEffect(() => {
    if (type && code) {
      props.onChange({
        tax_id: code,
        type
      });
    } else {
      props.onChange(null);
    }
  }, [type, code]);

  let types = TAX_ID_MAPPING.filter((c) => (props.country_code ? c.country === props.country_code : true));

  const InputWidget = (
    <Input
      disabled={types.length === 0}
      value={types.length !== 0 ? code || '' : ''}
      onChange={({ target }) => {
        if (target.value.trim() === '') {
          return setCode(null);
        }
        setCode(target.value);
      }}
    />
  );

  if (types.length <= 1) {
    return (
      <S.Container className={props.className}>
        <InputWrapperWidget label="VAT number (optional)">{InputWidget}</InputWrapperWidget>
      </S.Container>
    );
  }

  return (
    <S.Container className={props.className}>
      <S.Wrapper label="VAT number">
        <S.Select
          options={types
            .map((t) => {
              return {
                label: t.description,
                value: t.type
              };
            })
            .concat([
              {
                value: '',
                label: 'None'
              }
            ])}
          value={{
            value: types.find((t) => t.external_type === type)?.external_type,
            label: types.find((t) => t.external_type === type)?.description || 'None'
          }}
          onChange={(option: any) => {
            if (option === '') {
              setType(null);
            } else {
              setType(option.value);
            }
          }}
          isSearchable={false}
        />
        {!type ? null : InputWidget}
      </S.Wrapper>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    width: 300px;
  `;

  export const Select = styled(SelectWidget)`
    margin-bottom: 4px;
  `;

  export const Wrapper = styled(InputWrapperWidget)`
    margin-bottom: 13px;
  `;
}
